import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { MSelect } from "components/Shared";
import { allCountiesFromBoundaries } from "selectors/menuItems";
import Box from "@mui/material/Box";

const RequestCoverage = props => {
  const [coverageRequests, setCoverageRequests] = useState([{
    countyId: null,
    volume: null,
    selectedState: null,
    selectedCounty: null,
    filteredCounties: [],
  }]);
  const additionalInfo = useRef("");

  const onStateChange = (option, index) => {
    let updatedRequests = coverageRequests.map((request, i) => {
      if (i === index) {
        return {
          ...request,
          selectedState: option,
          selectedCounty: null,
          countyId: null,
          filteredCounties: option ? props.allCountyOptions.filter(c => c.state === option.value) : [],
        };
      }
      return request;
    });
    setCoverageRequests(updatedRequests);
  };

  const onCountyChange = (option, index) => {
    let updatedRequests = coverageRequests.map((request, i) => {
      if (i === index) {
        return {
          ...request,
          selectedCounty: option,
          countyId: option?.value || null
        };
      }
      return request;
    });
    setCoverageRequests(updatedRequests);
  };

  const onVolumeChange = (value, index) => {
    let updatedRequests = coverageRequests.map((request, i) => {
      if (i === index) {
        return {
          ...request,
          volume: value
        };
      }
      return request;
    });
    setCoverageRequests(updatedRequests);
  };

  const addCoverageRequest = () => {
    let newRequest = {
      countyId: null,
      volume: null,
      selectedState: null,
      selectedCounty: null,
      filteredCounties: [],
    };
    setCoverageRequests([...coverageRequests, newRequest]);
  };

  const onSubmit = () => {
    props.onSubmit(coverageRequests, additionalInfo.current);
  };

  const stateOptions = props.stateList?.map(s => ({ label: s.stateName, value: s.stateAbbreviation })) || [];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <div>
        Looking for appraisal coverage? Mueller Reports can help. Select up to 10 states and counties below and let us know your anticipated monthly appraisal volume (optional).
      </div>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>State</TableCell>
            <TableCell>County</TableCell>
            <TableCell>Monthly Volume</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {coverageRequests.map((request, i) => i < 10 ? (
            <TableRow key={`coverageOption${i}`}>
              <TableCell>
                <MSelect
                  options={stateOptions}
                  isClearable
                  onChange={(option) => onStateChange(option, i)}
                  value={request.selectedState}
                  enableAllOption={false}
                  placeholder="Select State"
                />
              </TableCell>
              <TableCell>
                <MSelect
                  options={request.filteredCounties}
                  isClearable
                  onChange={(option) => onCountyChange(option, i)}
                  value={request.selectedCounty}
                  enableAllOption={false}
                  placeholder="Select County"
                />
              </TableCell>
              <TableCell>
                <TextField
                  variant="standard"
                  type="number"
                  size="small"
                  sx={{ minWidth: 100 }}
                  onChange={(e) => onVolumeChange(e.target.value, i)}
                />
              </TableCell>
            </TableRow>
          ) : null)}
        </TableBody>
      </Table>
      <Button variant="text" onClick={addCoverageRequest}>Add More</Button>
      <TextField
        id="request-coverage-comments"
        variant="standard"
        label="Additional information:"
        type="text"
        fullWidth
        onChange={(e) => additionalInfo.current = e.target.value}
      />
      <Box sx={{ display: "flex", gap: 1, flexDirection: "row", justifyContent: "center" }}>
        <Button onClick={onSubmit}>Submit</Button>
        <Button variant="text" color="secondary" onClick={props.onCancel}>Cancel</Button>
      </Box>
    </Box>
  );
};

RequestCoverage.propTypes = {
  onCancel: PropTypes.func, // Function to call to dismiss display of component
  onSubmit: PropTypes.func, // Function to call with list of coverage requests and additional comments
  // Redux
  stateList: PropTypes.array,
  allCountyOptions: PropTypes.array,
};

const mapStateToProps = state => ({
  allCountyOptions: allCountiesFromBoundaries(state),
  stateList: state.appraiser.stateList,
});

export default connect(mapStateToProps)(RequestCoverage);